<template>
  <div class="mail-body-action">
    <div
      class="action action1"
      @click="emitActivityToParrent(1)"
      v-show="selected_email"
      :data-tooltip="$t('components.email.actions.reply')"
    >
      <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.3 70.3"
      >
        <defs></defs>
        <g id="Layer_1-2">
          <path
            class="cls-2"
            d="M41.41,28.06h-20.31l5.24-5.84c.48-.54.43-1.37-.12-1.84-.55-.47-1.39-.43-1.87.12l-7.78,8.69c-.48.54-.43,1.37.12,1.84l8.46,7.34c.25.22.56.33.88.33.37,0,.73-.15.99-.44.48-.54.43-1.36-.12-1.84l-6.61-5.73h21.12c4.76,0,8.63,3.81,8.63,8.49s-3.87,8.49-8.63,8.49c-.73,0-1.33.58-1.33,1.31s.59,1.3,1.33,1.3c6.22,0,11.29-4.98,11.29-11.1s-5.06-11.1-11.29-11.1Z"
          />
          <rect class="cls-1" width="70.3" height="70.3" />
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.reply') }}</div>
    </div>
    <div
      class="action action2"
      @click="emitActivityToParrent(2)"
      v-show="selected_email"
      :data-tooltip="$t('components.email.actions.reply_all')"
    >
      <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.3 70.3"
      >
        <defs></defs>
        <g id="Layer_1-2">
          <path
            class="cls-2"
            d="M18.19,31.29l7.07-8.02c.5-.56.44-1.42-.12-1.92-.56-.5-1.42-.44-1.92.12l-7.96,9.03c-.5.56-.44,1.42.12,1.92l8.66,7.63c.26.23.58.34.9.34.38,0,.75-.16,1.02-.46.5-.56.44-1.42-.12-1.92l-7.64-6.73Z"
          />
          <path
            class="cls-2"
            d="M41.15,29.36h-12.59l5.36-6.08c.5-.56.44-1.42-.12-1.92s-1.42-.44-1.92.12l-7.96,9.03c-.24.27-.36.62-.34.98s.19.69.46.93l8.66,7.63c.26.23.58.34.9.34.38,0,.75-.16,1.02-.46.5-.56.44-1.42-.12-1.92l-6.76-5.96h13.42c4.87,0,8.83,3.96,8.83,8.83s-3.96,8.83-8.83,8.83c-.75,0-1.36.61-1.36,1.36s.61,1.36,1.36,1.36c6.37,0,11.55-5.18,11.55-11.55s-5.18-11.55-11.55-11.55Z"
          />
          <rect class="cls-1" width="70.3" height="70.3" />
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.reply_all') }}</div>
    </div>
    <div
      class="action action-indiv"
      @click="emitActivityToParrent(7)"
      v-show="selected_email"
      :data-tooltip="$t('components.email.actions.forward')"
    >
      <svg
    
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g> 
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.9697 6.46967C14.2626 6.17678 14.7374 6.17678 15.0303 6.46967L20.0303 11.4697C20.3232 11.7626 20.3232 12.2374 20.0303 12.5303L15.0303 17.5303C14.7374 17.8232 14.2626 17.8232 13.9697 17.5303C13.6768 17.2374 13.6768 16.7626 13.9697 16.4697L17.6893 12.75L9.5 12.75C8.78668 12.75 7.70002 12.9702 6.81323 13.6087C5.96468 14.2196 5.25 15.2444 5.25 17C5.25 17.4142 4.91421 17.75 4.5 17.75C4.08579 17.75 3.75 17.4142 3.75 17C3.75 14.7556 4.70198 13.2804 5.93677 12.3913C7.13332 11.5298 8.54665 11.25 9.5 11.25L17.6893 11.25L13.9697 7.53033C13.6768 7.23744 13.6768 6.76256 13.9697 6.46967Z"
            fill="#222223"
          ></path>
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.forward') }}</div>
    </div>
    <div
      class="action action3"
      @click="emitActivityToParrent(3)"
      :data-tooltip="$t('components.email.actions.new_draft')"
    >
      <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.3 70.3"
      >
        <defs></defs>
        <g id="Layer_1-2">
          <path
            class="cls-2"
            d="M43.4,54.64H14.65c-.65,0-1.17.52-1.17,1.17s.52,1.17,1.17,1.17h28.75c.65,0,1.17-.52,1.17-1.17s-.52-1.17-1.17-1.17Z"
          />
          <path
            class="cls-2"
            d="M54.65,21.93l-6.94-6.69c-.46-.45-1.2-.44-1.65.02l-4.51,4.61s-.09.05-.13.09c-.03.03-.04.08-.07.11l-18.38,18.77c-.14.14-.23.31-.29.49l-2.93,10.03c-.12.42,0,.87.31,1.17.22.21.51.33.81.33.13,0,.25-.02.38-.06l9.86-3.34c.17-.06.33-.16.46-.29l23.1-23.59c.22-.22.34-.52.33-.84,0-.31-.13-.61-.36-.83ZM30.1,45.34l-7.47,2.53,2.22-7.59,17.48-17.85,5.3,5.01-17.53,17.9ZM49.27,25.77l-5.3-5.01,2.96-3.02,5.25,5.06-2.91,2.97Z"
          />
          <rect class="cls-1" width="70.3" height="70.3" />
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.new_draft') }}</div>
    </div>
    <div
      class="action action4"
      v-show="canSaveAttachments"
      @click="emitActivityToParrent(4)"
      :data-tooltip="$t('components.email.actions.save_attachments')"
    >
      <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.3 70.3"
      >
        <defs></defs>
        <g id="Layer_1-2">
          <path
            class="cls-2"
            d="M37.51,34.46c.46-.46.45-1.2,0-1.66-.46-.46-1.2-.45-1.66,0l-4.8,4.83c-.61.61-.96,1.39-.98,2.21-.02.85.33,1.68.98,2.33,1.48,1.48,3.56,1.45,5.31-.08,1.53-1.33,6.95-7.52,7.13-7.73,1.06-1.06,1.64-2.47,1.64-3.97s-.58-2.91-1.64-3.97c-2.19-2.19-5.75-2.19-7.94,0l-7.35,7.35c-3.73,3.74-3.85,7.9-.32,11.43,1.4,1.4,3.27,2.1,5.11,2.1s3.48-.64,4.76-1.92l6.73-6.73c.46-.46.46-1.2,0-1.66-.46-.46-1.2-.46-1.66,0l-6.73,6.73c-1.7,1.7-4.77,1.61-6.56-.19-2.59-2.59-2.48-5.32.32-8.12l7.35-7.35c1.24-1.24,3.39-1.23,4.62,0,.62.62.96,1.44.96,2.31s-.34,1.69-1.01,2.37c-1.54,1.76-5.79,6.54-6.96,7.56-1.1.97-1.74.57-2.12.19-.2-.2-.29-.41-.29-.62,0-.21.11-.42.29-.61l4.8-4.83Z"
          />
          <path
            class="cls-2"
            d="M55.18,24.9l-9.15-8.8c-.17-.17-.41-.26-.65-.26h-24.68c-2.12,0-3.85,1.73-3.85,3.85v31.29c0,1.92,1.56,3.49,3.49,3.49h30.6c2.5,0,4.54-2.03,4.54-4.54v-24.35c0-.25-.1-.5-.29-.68ZM53.59,49.93c0,1.47-1.19,2.66-2.66,2.66h-30.6c-.89,0-1.61-.72-1.61-1.61v-31.29c0-1.09.89-1.97,1.97-1.97h24.31l8.59,8.26v23.95Z"
          />
          <rect class="cls-1" width="70.3" height="70.3" />
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.save_attachments') }}</div>
    </div>
    <div
      class="action action5"
      v-show="selected_email"
      @click="emitActivityToParrent(5)"
      :data-tooltip="$t('components.email.actions.save_communication')"
    >
      <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.3 70.3"
      >
        <defs></defs>
        <g id="Layer_1-2">
          <path
            class="cls-2"
            d="M55.18,24.43l-9.15-8.8c-.17-.17-.41-.26-.65-.26h-24.68c-2.12,0-3.85,1.73-3.85,3.85v31.29c0,1.92,1.56,3.49,3.49,3.49h30.6c2.5,0,4.54-2.04,4.54-4.54v-24.35c0-.25-.1-.5-.29-.68ZM53.59,49.45c0,1.47-1.19,2.66-2.66,2.66h-30.6c-.89,0-1.61-.72-1.61-1.61v-31.29c0-1.09.89-1.97,1.97-1.97h24.31l8.59,8.26v23.95Z"
          />
          <path
            class="cls-2"
            d="M40.01,36.59c-.39.1-.66.1-.9-.22-1.11-1.45-2.23-2.89-3.35-4.34-.29-.37-.25-.74-.11-1.17.46-1.51.96-3.01,1.27-4.54.43-2.14-.14-3.09-2.09-3.95h-1.12c-1.96.86-2.59,1.85-2.07,3.94.41,1.65,1.17,3.21,1.75,4.81.1.29.21.65.12.91-.88,2.41-1.8,4.81-2.75,7.2-.12.29-.46.57-.77.7-1.33.59-2.7,1.1-4.04,1.67-1.13.48-2.1,1.16-2.56,2.37v1.25s.06.08.07.12c.39,1.19,1.18,1.94,2.43,2.09,1.23.14,2.16-.42,2.79-1.46.88-1.44,1.72-2.92,2.59-4.36.14-.24.37-.5.62-.59,2.16-.77,4.33-1.49,6.5-2.25.47-.17.81-.05,1.21.22,1.83,1.27,3.86,2.04,6.11,2.04,1.92,0,3.24-1.9,2.61-3.69-.48-1.39-1.79-2.11-3.57-1.81-1.6.27-3.17.67-4.74,1.06ZM27.1,45.24c-.23.3-.8.53-1.16.47-.33-.06-.77-.53-.81-.86-.04-.36.23-.94.54-1.12,1-.59,2.09-1.05,3.14-1.56.05.06.11.12.16.18-.62.97-1.18,1.98-1.88,2.89ZM33.18,25.44c-.18-.79.34-1.38,1.05-1.4.74-.02,1.27.57,1.12,1.41-.21,1.18-.53,2.34-.8,3.51-.1.01-.21.02-.31.04-.36-1.18-.77-2.35-1.05-3.55ZM32.87,38.81c.63-1.73,1.24-3.41,1.87-5.1.93,1.18,1.85,2.34,2.78,3.53-1.51.51-3.03,1.03-4.65,1.58ZM45.66,37.16c.68-.08,1.16.47,1.15,1.11,0,.61-.46,1.1-1.11,1.09-1.55-.02-2.96-.57-4.31-1.27,0-.08,0-.15,0-.23,1.43-.24,2.85-.53,4.28-.7Z"
          />
          <rect class="cls-1" width="70.3" height="70.3" />
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.save_communication') }}</div>
    </div>
    <div
      class="action action6"
      v-show="selected_email"
      @click="openOutlook()"
      :data-tooltip="$t('components.email.actions.open_outlook')"
    >
      <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.3 70.3"
      >
        <defs></defs>
        <g id="Layer_1-2">
          <path
            class="cls-2"
            d="M53.63,20.31h-9.83l.03-2.47c0-.29-.12-.58-.34-.77-.22-.19-.52-.28-.81-.24l-25.8,3.49c-.5.07-.88.5-.88,1v27.66c0,.5.36.92.86,1l25.35,3.9c.05,0,.1.01.15.01.24,0,.47-.09.66-.24.22-.19.35-.47.36-.76l.04-2.9h10.21c.56,0,1.01-.45,1.01-1.01v-27.66c0-.56-.45-1.01-1.01-1.01ZM52.62,24.66v23.31h-8.78v-15.31l8.78-7.99ZM52.17,22.33l-8.34,7.59v-7.59h8.34ZM41.79,18.99l-.42,32.72-23.34-3.59v-25.91l23.76-3.22Z"
          />
          <path
            class="cls-2"
            d="M28.64,42.91c3.71,0,6.02-2.97,6.02-7.76s-2.48-7.76-6.02-7.76-6.02,3.19-6.02,7.76,2.31,7.76,6.02,7.76ZM25.03,35.15c0-2.57,1.13-5.35,3.61-5.35s3.61,2.77,3.61,5.35c0,1.25-.26,5.35-3.61,5.35s-3.61-4.09-3.61-5.35Z"
          />
          <rect class="cls-1" width="70.3" height="70.3" />
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.open_outlook') }}</div>
    </div>
    <div
      class="action action7"
      v-show="canSaveAttachments"
      @click="downloadZipFiles()"
      :data-tooltip="$t('components.email.actions.download')"
    >
      <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 70.3 70.3"
      >
        <defs></defs>
        <g id="Layer_1-2">
          <path
            class="cls-2"
            d="M43.65,34.52l-6.08,6.13v-13.24c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v13.13l-6.46-6.06c-.5-.47-1.29-.45-1.77.06s-.45,1.29.06,1.77l8.69,8.16c.24.23.55.34.86.34s.64-.12.89-.37l8.09-8.16c.49-.49.48-1.28,0-1.77-.49-.49-1.28-.48-1.77,0Z"
          />
          <path
            class="cls-2"
            d="M55.18,24.52l-9.15-8.8c-.17-.17-.41-.26-.65-.26h-24.68c-2.12,0-3.85,1.73-3.85,3.85v31.29c0,1.92,1.56,3.49,3.49,3.49h30.6c2.5,0,4.54-2.03,4.54-4.54v-24.35c0-.25-.1-.5-.29-.68ZM53.59,49.54c0,1.47-1.19,2.66-2.66,2.66h-30.6c-.89,0-1.61-.72-1.61-1.61v-31.29c0-1.09.89-1.97,1.97-1.97h24.31l8.59,8.26v23.95Z"
          />
          <rect class="cls-1" width="70.3" height="70.3" />
        </g>
      </svg>
      <div class="email-item-hover">{{ $t('components.email.actions.download') }}</div>
    </div>
  </div>
</template>

<script>
import { attachmentsAsZip } from "../../../../helpers/file";
import { switchGlobalLoaderState } from "../../../../helpers/loader/global";
import toastService from "../../../../services/toast.service";

export default {
  props: {
    selected_email: {
      type: Object,
      default: null,
    },
  },
  computed: {
    canSaveAttachments() {
      return this.selected_email
        ? this.selected_email.attachments.length > 0
        : false;
    },
  },
  methods: {
    openOutlook() {
      if (this.selected_email && this.selected_email.email) {
        window.open(this.selected_email.email.webLink, "_blank");
      }
    },
    async downloadZipFiles() {
      if (!this.selected_email || !this.selected_email.attachments) {
        return;
      }

      switchGlobalLoaderState(this.$t('components.email.packing_files'));
      try {
        const filename = this.selected_email.email.subject
          ? this.selected_email.email.subject.replaceAll(" ", "-")
          : 'attachments';
        await attachmentsAsZip(this.selected_email.attachments, filename);
        toastService.success(this.$t('components.email.download_success'));
      } catch (error) {
        toastService.error(this.$t('components.email.download_error'));
      } finally {
        switchGlobalLoaderState();
      }
    },
    /**
     * Method that sends to parent what to do.
     * @param {*} integer_val Integer value representing method in parent switch/case.
     */
    emitActivityToParrent(integer_val) {
      this.$emit("activitySetup", integer_val);
    },
    // Native Vue hover handlers instead of jQuery
    handleMouseEnter(event) {
      const hoverEl = event.currentTarget.querySelector('.email-item-hover');
      if (hoverEl) {
        hoverEl.style.display = 'flex';
        hoverEl.style.opacity = '1';
        hoverEl.style.right = '5rem';
      }
    },
    handleMouseLeave(event) {
      const hoverEl = event.currentTarget.querySelector('.email-item-hover');
      if (hoverEl) {
        hoverEl.style.display = 'none';
        hoverEl.style.opacity = '0';
        hoverEl.style.right = '4rem';
      }
    },
  },
  mounted() {
    // Add native event listeners to all action elements
    const actionElements = this.$el.querySelectorAll('.action');
    actionElements.forEach(el => {
      el.addEventListener('mouseenter', this.handleMouseEnter);
      el.addEventListener('mouseleave', this.handleMouseLeave);
    });
  },
  beforeDestroy() {
    // Cleanup event listeners to prevent memory leaks
    const actionElements = this.$el.querySelectorAll('.action');
    actionElements.forEach(el => {
      el.removeEventListener('mouseenter', this.handleMouseEnter);
      el.removeEventListener('mouseleave', this.handleMouseLeave);
    });
  }
};
</script>

<style></style>
